import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { TLineItemProps } from '../types/productLinesListing.types';
import RoutableSitecoreLink from '../../@shared/routableSitecoreLink';
import Picture from '../../@shared/picture';
import { googleClickCardEvent } from '../../../utils/analytics';
import { appendRootToRichTextInternalLinks } from '../../../utils/appendRootToRichTextInternalLinks.utils';

const LineItem: FC<TLineItemProps> = ({ url, lineItem, componentNumber }) => (
  <RoutableSitecoreLink
    field={{ value: { href: url } }}
    className="product-line-listing__line-item"
    editable={false}
    onClick={(): void => googleClickCardEvent(lineItem?.title, componentNumber)}
  >
    <div className="product-line-listing__line-item__image-wrapper">
      <Picture
        productImageProps={{
          desktopRendition: lineItem?.assets?.[0]?.rendition_desktop_size500,
          mobileRendition: lineItem?.assets?.[0]?.rendition_mobile_size500,
          alt: lineItem?.assets?.[0]?.alt,
          imageClassName: 'product-line-listing__line-item__image',
          pictureClassName: 'product-line-listing__line-item__fixed-aspect-ratio',
        }}
      />
    </div>
    <h2 className="product-line-listing__line-item__title">{lineItem?.title}</h2>
    <RichText
      field={{ value: appendRootToRichTextInternalLinks(lineItem?.description) }}
      className="product-line-listing__line-item__text rich-text"
      tag="div"
      editable={false}
    />
  </RoutableSitecoreLink>
);

export default LineItem;
